<template>
  <button
    class="template-card"
    :class="{ 'template-card--selected': selected }"
  >
    <div
      v-if="isNew || isUpdated"
      class="template-card-ribbon"
    >
      <span>{{ isNew ? 'NOVO' : 'ATUALIZADO' }}</span>
    </div>
    <img :src="image" />
    <h3 class="template-card__title">
      {{ name }}
    </h3>
    <span class="template-card__btn">Usar este modelo</span>
  </button>
</template>

<script>
export default {
  name: 'TemplateCard',
  props: {
    name: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    body: {
      type: Object,
      default() {
        return {};
      },
    },
    selected: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isUpdated: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.template-card {
  background-color: $lb-white;
  border: 1px solid $lb-light-gray;
  color: $gray-900;
  display: inline-flex;
  width: 200px;
  flex-direction: column;
  margin: 8px;
  padding: 0;
  position: relative;
  text-align: center;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);

  $card: &;

  &:hover {
    border-color: $crm-blue-primary;

    #{$card}__btn {
      display: inline;
    }
  }

  &--selected {
    border-color: $crm-blue-primary;
  }

  &__title {
    width: 100%;
    padding: 1em;
    font-size: $size-small;
    color: $gray-900;
  }

  &__btn {
    background-color: $crm-blue-primary;
    border-radius: 25px;
    color: $lb-white;
    display: none;
    font-size: $size-smaller;
    left: 50%;
    padding: 0.375rem 0.75rem;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 65%;
  }

  // Base ribbon style from https://www.cssportal.com/css-ribbon-generator/
  &-ribbon {
    overflow: hidden;
    position: absolute;
    right: -5px;
    top: -5px;
    text-align: right;
    width: 75px;
    height: 75px;
    z-index: 1;

    span {
      -webkit-transform: rotate(45deg);
      background: #79a70a;
      background: linear-gradient(#9bc90d 0%, #79a70a 100%);
      color: $lb-white;
      display: block;
      font-size: 10px;
      line-height: 20px;
      position: absolute;
      text-align: center;
      text-transform: uppercase;
      top: 19px;
      right: -21px;
      transform: rotate(45deg);
      width: 100px;

      &::before {
        border-bottom: 3px solid transparent;
        border-left: 3px solid #79a70a;
        border-right: 3px solid transparent;
        border-top: 3px solid #79a70a;
        content: '';
        position: absolute;
        left: 0px;
        top: 100%;
        z-index: -1;
      }

      &::after {
        border-bottom: 3px solid transparent;
        border-left: 3px solid transparent;
        border-right: 3px solid #79a70a;
        border-top: 3px solid #79a70a;
        content: '';
        position: absolute;
        right: 0px;
        top: 100%;
        z-index: -1;
      }
    }
  }
}
</style>
